/**
 * Driver Instructions field formatter
 */

import {useTextField} from '@hconnect/tuc-processes/fields/textField/useTextField'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'

import type {FieldFormatter} from './types'
import {createValueArray} from './utils'

export const useDriverInstructionsFormatter = (): FieldFormatter => {
  const {fieldValue: driverInstructions, defaultFieldValue: defaultDriverInstructions} =
    useTextField('driverInstructions')
  const driverInstructionsState = useChangeableField('driverInstructions')

  return (context) => {
    const {t} = context
    const requiresApproval = driverInstructionsState.state === 'requireDispatchConfirmation'
    const hasChanges = driverInstructionsState.isDirty
    const oldValue = defaultDriverInstructions || null
    const newValue = driverInstructions || null

    const values = createValueArray(
      oldValue,
      newValue,
      hasChanges,
      t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified')
    )

    return {values, requiresApproval, hasChanges}
  }
}
